import { ApolloCache } from "@apollo/client"

import { ProjectTypename } from "shared/types/Project"

import {
  ProjectChildrenFragment,
  ProjectChildrenFragmentDoc
} from "entities/projects/graphql/fragments.generated"

import { FAVORITES_PROJECT_ID } from "./useFavoriteMutations"

export function readFavoritesFragment(cache: ApolloCache<object>) {
  const cacheId = cache.identify({
    id: FAVORITES_PROJECT_ID,
    __typename: ProjectTypename
  })
  if (!cacheId) {
    return null
  }
  return cache.readFragment<ProjectChildrenFragment>(
    {
      id: cacheId,
      fragmentName: "ProjectChildren",
      fragment: ProjectChildrenFragmentDoc
    },
    true
  )
}
